export const NetworkSurveyCommsPlans:string[] = [
  "Data LTE - Three UK - Go2Sim",
  "Data LTE - EEUK - Go2Sim",
  "Data LTE - VFUK only - Go2Sim",
  "Data LTE - 02UK - Go2Sim"
]